import { useEffect } from 'react'
import { useHistory, generatePath } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { makePublicUrl } from 'app/utils/publicUrl'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import {
  useCurrentHomeSiteId,
  useNetworkHomeJobsRouteParams,
  useNetworkWLANIdRouteParams,
} from 'features/networkAi/hooks'
import { siteWlansFetchDataSelector } from 'features/networkAi/selectors'
import { fetchSiteWlansThunk } from 'features/networkAi/slice'
import { SpinnerCentered } from 'components/Loader'
import ROUTES from 'app/routes'
import { NetworkAIBackButton, NetworkAIBackIcon } from '../../styles'
import { WLANCreateContainer, ListWLANsHeaderWrapper } from '../styles'
import { network } from 'features/networkAi/messages'

import CreateWLANForm from 'features/networkAi/NetworkWizard/CreateWLANs/CreateWLANForm'
import { SiteWlan } from 'features/networkAi/types'
import { NEW_WLAN_NAME } from 'features/networkAi/NetworkWizard/CreateWLANs/CreateWLANForm/consts'
import { WhiteBlock } from 'components/Layout'

function WLANEditCreate() {
  const history = useHistory()
  const dispatch = useAppDispatch()
  const { formatMessage } = useIntl()

  const { rootDomainId, jobId, homeId } = useNetworkHomeJobsRouteParams()
  const { wlanId } = useNetworkWLANIdRouteParams()
  const siteWlans = useAppSelector(siteWlansFetchDataSelector.data)
  const isLoading = useAppSelector(siteWlansFetchDataSelector.isFetching)
  const siteId = useCurrentHomeSiteId({ homeId })

  const siteWlansWithNew: SiteWlan[] = Array.isArray(siteWlans)
    ? filterForSelected(siteWlans)
    : [{} as SiteWlan]

  function filterForSelected(siteWlans: SiteWlan[]) {
    let filteredList: SiteWlan[] = []
    siteWlans.forEach(function (site) {
      if (wlanId === site.id) {
        filteredList.push(site)
      }
    })
    if (filteredList.length === 0) {
      filteredList.push({} as SiteWlan)
    }
    return filteredList
  }

  useEffect(() => {
    siteId && dispatch(fetchSiteWlansThunk(siteId))
  }, [dispatch, siteId])

  const handleNavigateWLANsClick = () => {
    const pathname = generatePath(ROUTES.networkAi.dashboard.networkWLANs, {
      rootDomainId,
      jobId,
      homeId,
      siteId,
    })
    history.push(pathname)
  }

  return (
    <>
      <WLANCreateContainer>
        <NetworkAIBackButton onClick={handleNavigateWLANsClick}>
          <NetworkAIBackIcon
            src={makePublicUrl(`images/networkIcons/arrow-back.svg`)}
          />
          {formatMessage(network.backNetworkWLANs)}
        </NetworkAIBackButton>
      </WLANCreateContainer>

      <WLANCreateContainer>
        <ListWLANsHeaderWrapper>
          <WhiteBlock>
            {isLoading ? (
              <SpinnerCentered mt="200px" />
            ) : (
              siteWlans &&
              siteWlansWithNew.map((wlan, i) => {
                return (
                  <CreateWLANForm
                    key={wlan.id + i}
                    wlan={wlan}
                    siteId={siteId}
                    rootDomainId={rootDomainId}
                    jobId={jobId}
                    homeId={homeId}
                    wlanName={wlan.ssid || NEW_WLAN_NAME}
                    defaultExpanded={i === siteWlansWithNew.length - 1}
                    wizardMode={false}
                    onSubmit={() => siteWlans.push({} as SiteWlan)}
                  />
                )
              })
            )}
          </WhiteBlock>
        </ListWLANsHeaderWrapper>
      </WLANCreateContainer>
    </>
  )
}

export default WLANEditCreate
